/* angular:styles/component:css;ba8ba6cbe3d6ff0e66dd25c243a1cd64016d4a81e19d45c9867b8be06d5332df;/src/src/app/shared/components/formly/input-serial-number-wrapper.ts */
.input-box-wrapper {
  border-bottom: 1px solid var(--ion-color-dark);
}
.input-box {
  border: 1px solid var(--ion-color-dark);
  border-bottom: 1px solid var(--ion-color-dark);
  border-radius: 2px;
  width: 100%;
  padding-left: 2px;
}
.input-box ion-item {
  --min-height: auto;
}
.disabled-field {
  pointer-events: none;
  opacity: 0.5;
}
.disabled-field ion-input,
.disabled-field ion-label {
  color: var(--ion-color-medium);
}
.text-center {
  text-align: center;
}
@media (max-width: 768px) {
  .text-center {
    text-align: --webkit-center;
  }
  .input-box {
    max-width: 90%;
  }
}
@media (max-width: 480px) {
  .input-box {
    max-width: 100%;
  }
}
/*# sourceMappingURL=input-serial-number-wrapper.css.map */
